import { styled } from "@compiled/react";

export const StyledRelativePosition = styled.div({
    position: "relative"
});
